import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { CalendarOptions, DateSelectArg, EventClickArg, EventApi, FullCalendarModule , FullCalendarComponent } from '@fullcalendar/angular';
import { Draggable } from '@fullcalendar/interaction';
import { TokenStorageService } from '../_services/token-storage.service';
import { SubmissionService } from '../_services/submission.service';
import { NoteService } from 'app/_services/note.service';
import * as moment from 'moment'; 
import { AUTO_STYLE } from '@angular/animations';

@Component({
  selector: 'app-follow-ups',
  templateUrl: './follow-ups.component.html',
  styleUrls: ['./follow-ups.component.scss']
})
export class FollowUpsComponent implements OnInit {
  @ViewChild('calendar', { static: false }) calendar!: FullCalendarComponent;

  contactUUID: string = "";
  followUps: any = [];
  oldStartDate: string = "";
  oldEndDate: string = "";
  startDate: string = "";
  endDate: string = "";
  eventModal: any;
  eventName: string = "";
  submissionInfo: any = [];
  modalTitle: string = "";
  eventAddress: string = "";
  eventStartDate: any;
  eventEndDate: any;
  switch_created_date_year: any;
  client_created_date_year: any;
  submission_created_date_year: any;
  //english year remainder color
  year_color_en_bfr: string = "#952759";
  year_color_en_0: string = "#c0740b";
  year_color_en_1: string = "#ff9800";
  year_color_en_2: string = "#cf0b0b"; 
  year_color_en_3: string = "#952759"; 
  year_color_en_4: string = "#d64e08";
  //french year remainder color
  year_color_fr_bfr: string = "#36c";
  year_color_fr_0: string = "#03a9f4";
  year_color_fr_1: string = "#1f573d";
  year_color_fr_2: string = "#74a43c";
  year_color_fr_3: string = "#36c";
  year_color_fr_4: string = "#198754";

  /*------------------------------------------
  --------------------------------------------
  Define calendarOptions
  --------------------------------------------
  --------------------------------------------*/
  calendarOptions: CalendarOptions = {
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    buttonText: {
      today: 'Aujourdhui',
      month: 'Mois',
      week: 'Semaine',
      day: 'Jour',
    },
    initialView: 'dayGridMonth',
    firstDay: 1,
    height: 'auto',
    // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
    // showNonCurrentDates: false,
    weekends: true,
    editable: true,
    selectable: true,
    dayMaxEvents: 99,
    lazyFetching: true,
    progressiveEventRendering: false,
    // droppable: true, // this allows things to be dropped onto the calendar
    // drop: this.handleDropEvent.bind(this),
    // select: this.handleDateSelect.bind(this),
    dateClick: this.handleDateClick.bind(this), // bind is important!
    eventClick: this.handleEventClick.bind(this),
    eventsSet: this.handleEvents.bind(this),
    eventDrop: this.dropEvent.bind(this),
    loading(isLoading) {
      // TODO: Add loader
    },
  };

  constructor(
    private tokenStorage: TokenStorageService,
    private note: NoteService,
    private submission: SubmissionService
  ) { }

  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";

    //@ts-ignore
    this.eventModal = new window.bootstrap.Modal(
      document.getElementById('eventModal')
    );
  }

  ngOnDestroy(): void {
    this.closePopovers();
  }

  getFollowUps(date1: string, date2: string): void {
    this.note.getFollowUps$(this.contactUUID, 1, 2, date1, date2).subscribe({
      next: (data: any) => {
        this.followUps = [];
        console.log("Follow ups ", data);

        for(let i = 0; i < data.length; i++) {
          //console.log("note ",data.notes[i]);
            let address = data[i].address;
            let language_code = data[i].client_language_code;
            //" " + data.notes[i].address2 +  ", " + data.notes[i].city +  " " + data.notes[i].province + " " + data.notes[i].postalcode + " " +  data.notes[i].country;
            let color: string = "#cccccc";
            let en_color = "#952759";
            let fr_color = "#36c";

            this.submission_created_date_year = moment(data[i].proposition_created ).local().format('YYYY');

            this.client_created_date_year = moment(data[i].client_created).local().format('YYYY');
            this.client_created_date_year = Number(this.client_created_date_year );
            //console.log('Y created', this.client_created_date_year + ' [' + data[i].client_created + '] ' + this.client_created_date_year % 5);
  
            if ( this.client_created_date_year >2023 || this.submission_created_date_year > this.client_created_date_year ) {

             // console.log('this.client_created_date_year', this.client_created_date_year + ' '+language_code+ ' '+address);

             //console.log("entity_id ", data[i].entity_id);

             if(this.submission_created_date_year > this.client_created_date_year ){
              this.switch_created_date_year = this.submission_created_date_year;
                //console.log("most recent submission i:", i + ' ' + data[i].entity_id);
             }else{
              this.switch_created_date_year = this.client_created_date_year;
             }

             //if(this.submission_created_date_year > this.client_created_date_year && data[i].is_refused == false) {
                //this.client_created_date_year = this.submission_created_date_year ;
                //console.log("most recent submission ", this.submission_created_date_year);
             //}
               
              switch (this.switch_created_date_year  % 5){

                case (0):  
                  en_color = this.year_color_en_0;
                  fr_color = this.year_color_fr_0;
                  break;

                case (1):  
                  en_color = this.year_color_en_1;
                  fr_color = this.year_color_fr_1;
                  break;
                
                case (2):  
                  en_color = this.year_color_en_2;
                  fr_color = this.year_color_fr_2;
                  break;

                case (3):  
                  en_color = this.year_color_en_3;
                  fr_color = this.year_color_fr_3;
                  break;
                
                case (4):  
                  en_color = this.year_color_en_4; 
                  fr_color = this.year_color_fr_4;
                  break;
              }
            }  

            if(language_code == 'EN' ) { color = en_color };
            if(language_code == 'FR' ) { color = fr_color };  
 /*
            if (data[i].is_accepted) {
              color = "#006633";//green
            }
            
            if (data[i].has_contract_signed) {
              color = "#006633";//green
            }
  */
            if (data[i].is_refused) {
              color = "#db2f4d";
              //color = "#bb0200";//green
            }

            if(!data[i].notified){
              //border_not_notified = " event-border"; //red border
            }
            

            this.followUps.push(
              {
                "id": data[i].note_id,
                "title": address,
                "start": moment(data[i].start_date).local().format('YYYY-MM-DD'),
                "end": moment(data[i].end_date).local().format('YYYY-MM-DD'),
                "backgroundColor": color,
                "extendedProps": data[i]
              }
            )
        }

        this.calendarOptions.events = this.followUps;
      },
      error: (err: any) => {
        console.log("Something went wrong fetching follow ups: ", err);
      }
    })
    
    console.log("followUps" , this.followUps)
  }

  handleEvents(events: any): void {
    const calendarApi = this.calendar.getApi();
    const dates = calendarApi.getCurrentData();

    let startDate = moment(dates.dateProfile.activeRange!.start).format('YYYY-MM-DD');
    let endDate = moment(dates.dateProfile.activeRange!.end).format('YYYY-MM-DD');

    if (this.oldStartDate !== startDate) {
      console.log('start+end ', startDate, endDate);
      this.getFollowUps(startDate, endDate);
      this.oldStartDate = startDate
    }
    
    this.closePopovers();
  }

  dropEvent(info: any): void {
    const noteInfos = info.event;

    let noteInfo = {
      "note_id": noteInfos.id,
      "updated": noteInfos._def.extendedProps.updated,
      "note_type_id": noteInfos._def.extendedProps.note_type_id,
      "note_entity_id": noteInfos._def.extendedProps.note_entity_id,
      "entity_id": noteInfos._def.extendedProps.entity_id,
      // "subject": noteInfos._def.extendedProps.subject,
      // "body": noteInfos._def.extendedProps.body,
      "start_date": noteInfos.start,
      "end_date": noteInfos.start,
      "active": noteInfos._def.extendedProps.active
    }

    console.log('noteInfo', noteInfo);

    this.note.updateNote$(this.contactUUID, noteInfo).subscribe({
      next: (data: any) => {
        console.log("updated note: ", data)
      },
      error: (err: any) => {
        console.log("Something went wrong updating the note: ", err)
      }
    })
  }
    
  handleEventHover(event: any): void {
    console.log("handleEventHover ", event)
  }

  handleDateClick(event: any): void {
    console.log("handleDateClick ", event);
    this.closePopovers();
  }

  getSubmission(info: any): void {
    this.submission.getSubmission$(info.event._def.extendedProps.submission.submission_id, this.contactUUID).subscribe({
      next: (data: any) => {
        console.log("Submission: ", data)
        this.submissionInfo = data;
      },
      error: (err: any) => {
        console.log("Something went wrong getting the submission: ", err)
      }
    })
  }

  handleEventClick(clickInfo: EventClickArg): void {
    const submissionInfo = clickInfo.event._def.extendedProps;

    console.log("clickInfo", clickInfo);
    console.log('submissionInfo', submissionInfo);

    // this.modalTitle = submissionInfo.submission_no;

    // this.eventAddress = submissionInfo.address + " " + submissionInfo.address2 + " " + submissionInfo.city + ", " + submissionInfo.province + ", " + submissionInfo.country;

    // this.eventStartDate = clickInfo.event.start;
    // this.eventEndDate = clickInfo.event.end;

   //this.eventModal.show();

    this.closePopovers();

    //@ts-ignore
    const eventPopover = new bootstrap.Popover(clickInfo.el, {
      animation: true,
      container: "body",
      html: true,
      placement: "auto",
      trigger: "focus",
      title: clickInfo.event.title,
      content:'<div class="d-flex"><span>' + submissionInfo['client_first_name'] + " " + submissionInfo['client_last_name'] + '</span></div>' +
              '<div class="d-flex justify-content-end action-icons">' +
                '<a type="button" class="btn btn-outline-secondary left-action-btn" href="/client/' + submissionInfo['client_id'] + '/editer">' +
                  '<i class="bbi bi bi-person" title="Modifier le client"></i>' +
                '</a>' +
                '<a type="button" class="btn btn-outline-secondary right-action-btn" href="/soumission/' + submissionInfo['submission_id'] + '/editer">' +
                  '<i class="bi bi-pencil-square" title="Voir la soumission"></i>' +
                '</a>' +
              '</div>'
    })

    eventPopover.show();
  }

  openModal(info: any): void {
    console.log("info ", info)
  }

  closePopovers(): void {
    const popoverTriggerList = document.querySelectorAll('.bs-popover-auto');
    for (let i = 0; i < popoverTriggerList.length;i++) {
        console.log("popover", popoverTriggerList[i])
        popoverTriggerList[i].remove();
    }
  }
}